<div *ngIf="!isCheckingSession" class="verification-container">
  <h1 class="page-title">{{ 'sms_verification.title' | translate }}</h1>
  <p class="page-hint">
    {{ 'sms_verification.body' | translate }}
  </p>
  <h2 class="section-subheading">
    {{ 'sms_verification.subheading' | translate }}
    <span class="asterisk"> *</span>
  </h2>
  <p class="section-hint">{{ 'sms_verification.hint' | translate }}</p>

  <app-notice size="sm" icon="info" [title]="'notice.hints.is_verified' | translate"></app-notice>

  <!-- Phone Number Step -->
  <div class="verification-step" *ngIf="currentStep === 'phone'">
    <div class="card">
      <div class="card-header">
        <span class="card-icon">
          <mat-icon class="material-symbols-outline">mobile</mat-icon>
        </span>
        <div class="card-title-container">
          <span class="card-title">{{ 'sms_verification.steps.step_1.title' | translate }}</span>
          <p class="card-subtitle">{{ 'sms_verification.steps.step_1.body' | translate }}</p>
        </div>
      </div>
      <form [formGroup]="phoneForm" (ngSubmit)="sendVerificationCode()">
        <div class="phone-input-group">
          <mat-form-field appearance="fill">
            <input
              matInput
              type="text"
              formControlName="phoneNumber"
              class="phone-input"
              [class.error]="getPhoneError()"
              [placeholder]="'sms_verification.steps.step_1.placeholder' | translate"
              maxlength="10"
            />
          </mat-form-field>
          <!-- <app-notice 
            *ngIf="getPhoneError()" 
            size="sm" 
            icon="warning" 
            type="danger"
            fill="transparent"
            [title]="getPhoneError()">
          </app-notice> -->
          <p class="form-hint">
            <mat-icon>lock</mat-icon>{{ 'sms_verification.steps.step_1.hint' | translate }}
          </p>
        </div>

        <!-- Error Notice -->
        <app-notice
          *ngIf="error && !getPhoneError()"
          size="sm"
          icon="error"
          type="danger"
          fill="transparent"
          [title]="error"
        >
        </app-notice>
        <rm-button
          class="full-width submit-btn text-normal"
          [ngClass]="{ disabled: isLoading || phoneForm.invalid }"
          design="primary"
          [rounded]="true"
          type="submit"
          size="sm"
          [disabled]="isLoading || phoneForm.invalid"
          ><span *ngIf="isLoading" class="spinner"></span
          >{{
            (isLoading
              ? 'sms_verification.steps.step_1.sending'
              : 'sms_verification.steps.step_1.send_code'
            ) | translate
          }}</rm-button
        >
      </form>
    </div>
  </div>

  <!-- Verification Code Step -->
  <div class="verification-step" *ngIf="currentStep === 'verification'">
    <div class="card">
      <div class="card-header">
        <span class="card-icon">
          <mat-icon class="material-symbols-outline">sms</mat-icon>
        </span>
        <div class="card-title-container">
          <span class="card-title">{{ 'sms_verification.steps.step_2.title' | translate }}</span>
          <p class="card-subtitle">{{ 'sms_verification.steps.step_2.body' | translate }}</p>
        </div>
      </div>

      <form [formGroup]="verificationForm" (ngSubmit)="verifyCode()">
        <div class="verification-input-group">
          <mat-form-field appearance="fill">
            <input
              matInput
              type="text"
              formControlName="code"
              class="verification-code-input"
              [class.error]="getVerificationError()"
              placeholder="{{ 'sms_verification.steps.step_2.placeholder' | translate }}"
              maxlength="6"
              autocomplete="one-time-code"
            />
          </mat-form-field>
          <p class="form-hint">
            <mat-icon>send</mat-icon>{{ 'sms_verification.steps.step_2.code_sent_to' | translate }}:
            +1{{ phoneForm.value.phoneNumber }}
            <button *ngIf="canResend" type="button" class="btn-link sm" (click)="editPhoneNumber()">
              {{ 'sms_verification.steps.step_2.edit_number' | translate }}
            </button>
          </p>
        </div>
        <!-- Success Notice -->
        <app-notice
          *ngIf="isVerified"
          size="sm"
          icon="check"
          type="success"
          [title]="'sms_verification.steps.step_2.verified_success' | translate"
        >
        </app-notice>

        <!-- Error Notice -->
        <app-notice
          *ngIf="error"
          size="sm"
          icon="error"
          type="danger"
          fill="transparent"
          [title]="error"
        >
        </app-notice>
        <app-notice
          *ngIf="getVerificationError()"
          size="sm"
          icon="error"
          type="danger"
          fill="transparent"
          [title]="getVerificationError()"
        >
        </app-notice>

        <rm-button
          class="full-width submit-btn text-normal"
          [ngClass]="{ disabled: isLoading || verificationForm.invalid }"
          design="primary"
          [rounded]="true"
          type="submit"
          size="sm"
          [disabled]="isLoading || verificationForm.invalid"
          ><span *ngIf="isLoading" class="spinner"></span
          >{{
            (isLoading
              ? 'sms_verification.steps.step_2.verifying'
              : 'sms_verification.steps.step_2.verify_code'
            ) | translate
          }}</rm-button
        >
      </form>

      <div class="resend-section">
        <span class="text-grey" *ngIf="canResend">{{
          'sms_verification.steps.step_2.did_not_receive' | translate
        }}</span>
        <button
          type="button"
          class="btn-link"
          [disabled]="!canResend || isLoading"
          (click)="resendCode()"
        >
          <span *ngIf="canResend">{{ 'sms_verification.steps.step_2.resend' | translate }}</span>
          <span *ngIf="!canResend && resendCountdown$">
            <span *ngIf="resendCountdown$ | async as countdown">
              {{ 'sms_verification.steps.step_2.resend_in' | translate }} {{ countdown }}s
            </span>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
